var map = {
	"./pt01.png": "c92c",
	"./pt02.png": "08c9",
	"./pt03.png": "f674",
	"./pt04.png": "afd5",
	"./pt05.png": "9e94",
	"./pt06.png": "8356",
	"./pt07.png": "e51b",
	"./pt08.png": "69f6",
	"./pt09.png": "bf04",
	"./pt10.png": "81ef",
	"./pt11.png": "820b",
	"./pt12.png": "2666",
	"./pt13.png": "159d",
	"./pt14.png": "d6dd",
	"./pt15.png": "b6e6",
	"./pt16.png": "5d85",
	"./pt17.png": "8790",
	"./pt18.png": "bee0",
	"./pt19.png": "20dc",
	"./pt20.png": "70f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c8c9";